/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHome = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.982 2 2 8.686V22h20V8.686zM4 9.727l8-5.3 8 5.3V20H4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHome as Home };
